import { useTranslation } from 'react-i18next';
import { ty } from '@client/styles/typography';
import { ContentSectionFullHeight } from '../connect-container';

export const MeterConclusion = (): JSX.Element => {
  const { t } = useTranslation('connect', { keyPrefix: 'components.smtMeterConclusion' });
  return (
    <ContentSectionFullHeight centerContentVertically>
      <p className={ty('paragraph600')}>{t('description')}</p>
    </ContentSectionFullHeight>
  );
};
